/**
 * Используйте данную функцию для разового вызова функции
 */
export function once(fn) {
  let called = false;
  return function onced(...args) {
    if (!called) {
      called = true;
      fn.apply(this, args);
    }
  };
}